// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { AssetsAnalyticsPage } from '#components/domain/operations/analytics/assets/assets-analytics-page.tsx'

export const Route = createFileRoute('/_app/$companyId/analytics/assets')({
  component: AssetsAnalyticsPage,
  staticData: { title: 'Analysis', appShell: true },
})
